import produce from "immer";
import { IStoreState } from "../../initialStoreState";
import { LoadState } from "../../../constants/enums";
import { initialAccountingPaymentAccountsRecievableState } from "./PaymentAccountsRecievable.types";
import { AccountingPaymentAccountsRecievableActions } from ".";
import {
  CLEAR_ACCOUNTING_PAYMENT_ACCOUNTS_RECIEVABLE,
  FETCH_ACCOUNTING_PAYMENT_ACCOUNTS_RECIEVABLE_FAILURE,
  FETCH_ACCOUNTING_PAYMENT_ACCOUNTS_RECIEVABLE_LIST_FAILURE,
  FETCH_ACCOUNTING_PAYMENT_ACCOUNTS_RECIEVABLE_LIST_PROGRESS,
  FETCH_ACCOUNTING_PAYMENT_ACCOUNTS_RECIEVABLE_LIST_SUCCESS,
  FETCH_ACCOUNTING_PAYMENT_ACCOUNTS_RECIEVABLE_PROGRESS,
  FETCH_ACCOUNTING_PAYMENT_ACCOUNTS_RECIEVABLE_SUCCESS,
} from "./PaymentAccountsRecievableActions";

export const AccountingPaymentAccountsRecievableReducer = (
  state: IStoreState["accounting"]["paymentAccountsRecievable"] = initialAccountingPaymentAccountsRecievableState,
  action: AccountingPaymentAccountsRecievableActions
) => {
  switch (action.type) {
    case FETCH_ACCOUNTING_PAYMENT_ACCOUNTS_RECIEVABLE_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.InProgress;
      });
      return newState;
    }

    case FETCH_ACCOUNTING_PAYMENT_ACCOUNTS_RECIEVABLE_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.Loaded;
        draftState.data = data;
      });
      return newState;
    }

    case FETCH_ACCOUNTING_PAYMENT_ACCOUNTS_RECIEVABLE_FAILURE: {
      const { errorMessage } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.Failed;
        draftState.error = errorMessage;
      });
      return newState;
    }

    case FETCH_ACCOUNTING_PAYMENT_ACCOUNTS_RECIEVABLE_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.listLoading = LoadState.InProgress;
      });
      return newState;
    }

    case FETCH_ACCOUNTING_PAYMENT_ACCOUNTS_RECIEVABLE_LIST_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.listLoading = LoadState.Loaded;
        draftState.list = data;
      });
      return newState;
    }

    case FETCH_ACCOUNTING_PAYMENT_ACCOUNTS_RECIEVABLE_LIST_FAILURE: {
      const { errorMessage } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.listLoading = LoadState.Failed;
      });
      return newState;
    }

    case CLEAR_ACCOUNTING_PAYMENT_ACCOUNTS_RECIEVABLE: {
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.NotLoaded;
        draftState.data = initialAccountingPaymentAccountsRecievableState.data;
        draftState.error = null;
      });
      return newState;
    }

    default:
      return state;
  }
};
